import React, { useMemo } from "react";

import {
  Alert,
  Divider,
  MarkdownLite,
  Stack,
  Text,
} from "@origin-digital/ods-core";
import { Description, DescriptionList } from "../../components/DescriptionList";
import { formatAbn } from "../../utils/helpers";
import { generateMailto } from "../UpdateAddress/UpdateAddressScreen/helpers";
import { AddressProp } from "../UpdateAddress";
import content from "./content.json";

export interface BusinessAccountProp {
  abn: string;
  name: string;
}

export interface BusinessDetailsProp {
  addresses: AddressProp[];
  businessAccounts: BusinessAccountProp[];
}

export interface IProps {
  businessDetails: BusinessDetailsProp;
}

const mapView = (
  prop: BusinessAccountProp,
  idx: number,
  arrayObj: BusinessAccountProp[]
) => {
  const hasMultiple = arrayObj.length > 1;
  return {
    ...prop,
    nameLabel: hasMultiple
      ? `${content.business.name} ${idx + 1}`
      : `${content.business.name}`,
    abnLabel: hasMultiple
      ? `${content.business.abn} ${idx + 1}`
      : `${content.business.abn}`,
  };
};

export const BusinessDetail: React.FC<IProps> = ({
  businessDetails: { addresses, businessAccounts },
}) => {
  const alertText = useMemo(
    () => generateMailto(addresses, content.business.message),
    [addresses]
  );

  if (businessAccounts.length === 0) {
    return null;
  }

  const businessAccountViews = businessAccounts.map(mapView);
  const truncBusinessAccounts = businessAccountViews.slice(0, 5);

  return (
    <Stack>
      <DescriptionList
        data-id="business-details"
        heading={content.business.heading}
      >
        {truncBusinessAccounts.map((business) => {
          return (
            <Stack key={business.abn} data-id={business.abn} space="medium">
              <Description
                data-id="name"
                label={business.nameLabel}
                value={business.name}
              />
              <Divider />
              <Description
                data-id="abn"
                label={business.abnLabel}
                value={formatAbn(business.abn)}
              />
              <Divider />
            </Stack>
          );
        })}
        {businessAccounts.length > 5 && (
          <Alert data-id="info-message">
            <Stack space="medium">
              <Text weight="medium">{content.business.info}</Text>
              <Text>
                <MarkdownLite>{alertText}</MarkdownLite>
              </Text>
            </Stack>
          </Alert>
        )}
      </DescriptionList>
    </Stack>
  );
};
